/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationRecapQuery = gql`
  query GetSimulationRecapQuery {
    getSimulationRecap_simulation_recap {
      projectStatus 
      user {
 emails {
 value  
} 
firstName  
lastName  
}
      customer {
 civility  
firstName  
lastName  
birthDate  
addresses {
 fields  
city  
zipCode  
} 
socialSecurities {
 regime  
} 
isTNS  
emails {
 value  
} 
phones {
 internationalCode  
number  
isMobile  
} 
CSPs {
 label  
externalId  
categoryCSPExternalId  
categoryLvl1CSPExternalId  
} 
finances {
 annualIncome  
} 
professionalStatus  
subscriptionStatus  
}
      grantees {
 civility  
type  
birthDate  
firstName  
lastName  
socialSecurities {
 regime  
} 
}
      commission {
 rate  
type  
}
      offer {
 effectDate  
packs {
 id  
customerId  
granteeId  
externalId  
pricings {
 id  
isPreSelected  
isSelected  
level  
moduleLabel  
moduleCode  
supplementaryCover  
prices {
 price  
defaultPrice  
initialPrice  
} 
isRecommended  
} 
} 
code  
}
      paymentFrequency 
      documentsToDownload {
 code  
label  
source  
tag  
featureName  
bundleTag  
filePath  
}
      collectionNeeds {
 isDutyOfAdviceSkipped  
customerAgreement  
}
      canContinueToSubscription 
      guarantees {
 code  
parentCode  
type  
label  
legend  
isSelected  
values  
annualPrice  
monthlyPrice  
}
      prices {
 EMPLOYEE {
 monthly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
yearly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
totalBudgetEstimate {
 monthly  
yearly  
} 
totalBudgetEstimateByCompany {
 monthly  
yearly  
} 
label  
unit  
} 
PARTNER {
 monthly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
yearly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
label  
unit  
} 
CHILD {
 monthly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
yearly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
label  
unit  
} 
FAMILY {
 monthly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
yearly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
totalBudgetEstimate {
 monthly  
yearly  
} 
totalBudgetEstimateByCompany {
 monthly  
yearly  
} 
label  
unit  
} 
DUO {
 monthly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
yearly {
 product  
option  
optionsDetail {
 name  
amount  
unit  
} 
} 
label  
unit  
} 
}
      demography {
 childrenCount  
partnerCount  
employeeAverageAge  
employeeCount  
college  
employerPercentCount  
employerPercentShare  
tariffStructure  
socialSecurities {
 regime  
} 
}
      company {
 name  
siret  
siren  
ccnId  
ccnName  
}
      monthlyPrice 
      monthlyPriceMadelin 
      annualPrice 
      annualPriceMadelin 
      pricingLevel 
      formulaLevelLabel 
      tariffStructureLabel 
      beneficiariesEnrollment 
      canSendMail 
    }
  }
`;

export default GetSimulationRecapQuery;
